module.exports = __webpack_public_path__ + "tb-wireframe3.jpg?baa4ecd3d1ba6f412a5acd6ed10d93bc";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/tb-wireframe3.jpg
// module id = 242
// module chunks = 0